import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';

/**
 * One place that decides retry and staleness, so no screen has to.
 *
 * The important rule: never retry a 4xx. A 403 or a 404 will not become a 200
 * by asking three more times — it just delays the error the user needs to see.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: { retry: false },
  },
});
